import React from 'react';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import CustomTooltip from '../../../Tooltip';
import TreeGoalActions from '../../../TreeGoalActions/TreeGoalActions';
import UserStore from '../../../../stores/UserStore';
import { I18nFormatter } from '../../../../utils/I18n/I18n';
import { buildUiUrl } from '../../../../helpers/urlBuilder';
import helperColumns from '../../../DataComponent/helper';
import {
    getConversionStatus
} from '../../../../helpers/common';
// removed unused imports

const conversions = (state) => state.conversions.list;
const serverStore = (state) => state.serverStorage.store;
const totalPages = (state) => state.conversionsTotal.totalPages;
const totalItems = (state) => state.conversionsTotal.totalItems;

const images = {
    eye: require('img/icons/icon-eye.svg'),
};

export const getTotalPages = createSelector(
    totalPages,
    (totalPages = []) => {
        return totalPages;
    }
);

export const getTotalItems = createSelector(
    totalItems,
    (totalItems = []) => {
        return totalItems;
    }
);

export const mainSelector = createSelector(
    conversions,
    (conversions = []) => {
        const staticNamesAction = UserStore.getTranslation().actions;
        let list = [];

        conversions.map((item, i) => {
            const conversionPath = buildUiUrl('conversion', { id: item.ConversionId });
            list.push({
                id: <Link to={conversionPath}>{item.ConversionId}</Link>,
                createdAt: I18nFormatter.fullDateTime(helperColumns.toTimestamp(item.ConversionDateTime)),
                updatedAt: I18nFormatter.fullDateTime(helperColumns.toTimestamp(item.FactDateTime)),
                status: getConversionStatus(item.FactStatus),
                timeFromTrackToAction: I18nFormatter.fromDate(helperColumns.toTimestamp(item.TrackDateTime), helperColumns.toTimestamp(item.ConversionDateTime)),
                publisher: item.Publisher,
                advCid: item.AdvertiserUID,
                goalTitle: <TreeGoalActions data={[{...item}]} nestingLevel={2} />,
                goalActions: <TreeGoalActions data={[{...item}]} />,
                typeAction: item.GoalActionActionType,
                saleSum: I18nFormatter.currency(item.SaleSumAmount, item.SaleSumCurrency, true),
                publisherCreditPerLead: I18nFormatter.currency(item.PublisherCreditPerLeadAmount, item.PublisherCreditPerLeadCurrency, true),
                createdAtTrack: I18nFormatter.fullDateTime(+helperColumns.toTimestamp(item.TrackDateTime)),
                ip: item.Ip,
                utm_source: item.UtmSource,
                utm_medium: item.UtmMedium,
                utm_campaign: item.UtmCampaign,
                utm_term: item.UtmTerm,
                utm_content: item.UtmContent,
                param1: item.Param1,
                param2: item.Param2,
                param3: item.Param3,
                param4: item.Param4,
                actions: (
                    <div className="row-controls">
                        <CustomTooltip id={`more-info-${i}`} tooltip={staticNamesAction.view}>
                            <Link className="control-item view-button" to={conversionPath}>
                                <img src={images.eye} alt=""/><span className={'link-title'}>{staticNamesAction.view}</span>
                            </Link>
                        </CustomTooltip>
                    </div>
                )
            });
        });
        
        return list;
    }
);

export const getHeaderName = createSelector(
    serverStore,
    () => {
        return helperColumns.getDate('conversions');
    }
);
